import BiwaScheme from 'biwascheme';


import {daysBetween2,getCurrentDateYMD,plus_days2} from '@/services/zeit';
import {init,draw_circle_st,clear_rect,set_size_to_window} from '@/services/dermotor';
import {drawCell} from '@/services/zelle';



BiwaScheme.define_libfunc("test", 2, 2, function(ar){
  BiwaScheme.assert_integer(ar[0]);
  BiwaScheme.assert_integer(ar[1]);
  return ar[0] + ar[1];
});


BiwaScheme.define_libfunc("date-diff", 2, 2, function(ar){
 // BiwaScheme.assert_integer(ar[0]);
    // BiwaScheme.assert_integer(ar[1]);
    return daysBetween2(ar[0],ar[1])

});

BiwaScheme.define_libfunc("date-today", 0, 0, function(ar){
 // BiwaScheme.assert_integer(ar[0]);
    // BiwaScheme.assert_integer(ar[1]);
    return getCurrentDateYMD()
//    return daysBetween2(ar[0],ar[1])

});


BiwaScheme.define_libfunc("date-days-add", 2, 2, function(ar){
 // BiwaScheme.assert_integer(ar[0]);
    // BiwaScheme.assert_integer(ar[1]);
    return plus_days2(ar[0],ar[1])


});






BiwaScheme.define_libfunc("date-today", 0, 0, function(ar){
 // BiwaScheme.assert_integer(ar[0]);
    // BiwaScheme.assert_integer(ar[1]);
    return getCurrentDateYMD()
//    return daysBetween2(ar[0],ar[1])

});


//canvas
BiwaScheme.define_libfunc("draw-clear", 0, 0, function(ar){
 // BiwaScheme.assert_integer(ar[0]);
    // BiwaScheme.assert_integer(ar[1]);
   let st = init('bottom_canvas')

    set_size_to_window(st.ctx)
    clear_rect(st.ctx)
    return true
//    return daysBetween2(ar[0],ar[1])

});


BiwaScheme.define_libfunc("draw-circle", 0, 0, function(ar){
 // BiwaScheme.assert_integer(ar[0]);
    // BiwaScheme.assert_integer(ar[1]);
   let st = init('bottom_canvas')

    draw_circle_st(st,50,50,5,'red')
    return true
//    return daysBetween2(ar[0],ar[1])

});


BiwaScheme.define_libfunc("draw-cell", 0, 0, function(ar){
 // BiwaScheme.assert_integer(ar[0]);
    // BiwaScheme.assert_integer(ar[1]);
   let st = init('bottom_canvas')

    drawCell(st.ctx,st.canvas.width / 2, st.canvas.height / 2, 100, 60, 15, 100);
    return true
//    return daysBetween2(ar[0],ar[1])

});

function drawHSLRect(ctx,x, y, size, hue, saturation, luminance) {
      const hsl = `hsl(${hue}, ${saturation}%, ${luminance}%)`;
      ctx.fillStyle = hsl;
      ctx.fillRect(x, y, size, size);
}


BiwaScheme.define_libfunc("draw-square-hsl", 6, 6, function(ar){
 // BiwaScheme.assert_integer(ar[0]);
    // BiwaScheme.assert_integer(ar[1]);
   let st = init('bottom_canvas')

    drawHSLRect(st.ctx,ar[0],ar[1],ar[2],ar[3],ar[4],ar[5],ar[6])
    return true
//    return daysBetween2(ar[0],ar[1])

});

function getComplementSaturation(sat) {
  return 100 - sat;
}

function getComplementLuminance(lum) {
  return 100 - lum;
}


function rgbToHsl(r, g, b) {
  r /= 255;
  g /= 255;
  b /= 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h, s, l;

  l = (max + min) / 2;

  if (max === min) {
    h = s = 0; // achromatic
  } else {
    const d = max - min;

    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

    switch (max) {
      case r:
        h = ((g - b) / d + (g < b ? 6 : 0));
        break;
      case g:
        h = ((b - r) / d + 2);
        break;
      case b:
        h = ((r - g) / d + 4);
        break;
    }

    h /= 6;
  }

  return {
    h: Math.round(h * 360),
    s: Math.round(s * 100),
    l: Math.round(l * 100)
  };
}

//const hsl = rgbToHsl(250, 144, 49);
//console.log(hsl); // { h: 28, s: 95, l: 59 } (approx)



export function scheme_init() {
    console.log
}
